interface CountdownTimerProps {
  expiresAt?: number;
  remainingDays?: number;
}

export default function CountdownTimer({ expiresAt, remainingDays }: CountdownTimerProps) {
  // expiresAt = 0 means permanent
  if (expiresAt === 0 || (expiresAt && expiresAt > 4102444800)) {
    return (
      <div className="flex items-center gap-2">
        <div className="flex items-baseline gap-0.5">
          <span className="text-2xl font-black text-white">∞</span>
        </div>
        <span className="text-white/50 text-[11px]">永久有效</span>
      </div>
    );
  }

  if (remainingDays !== undefined && remainingDays > 0) {
    return (
      <div>
        <div className="flex items-baseline gap-1">
          <span className="text-3xl font-black text-white">{remainingDays}</span>
          <span className="text-white/50 text-[10px]">天剩余</span>
        </div>
        {expiresAt && expiresAt > 0 && (
          <div className="text-white/40 text-[10px] mt-1">
            有效期至 {new Date(expiresAt * 1000).toLocaleDateString()}
          </div>
        )}
      </div>
    );
  }

  return null;
}
